export const COMPANY_CODES: Record<number, string> = {
  9351: 'Home+ Services - PC tune up',
  9352: 'Home+ Services - Data Transfer',
  9353: 'Home+ Services - Virus Removal',
  9472: 'Verizon Anti-Virus Malware Check',
};
